import Extension from "../base/extension";

/**
 * Delegated behaviours for Bootstrap tab panes (switcher section, media
 * content tabs). Replaces the once-per-page inline scripts the snippets
 * previously emitted behind window flags.
 *
 * - Videos pause when their pane is deselected and autoplay videos resume
 *   when it is reselected, so nothing keeps playing inside hidden tabs.
 * - Swiper instances re-measure when their pane is shown (Swiper sees a
 *   zero-width container inside a hidden pane).
 * - In the theme editor, selecting a tab block in the sidebar activates its
 *   tab so the merchant sees the pane they are editing.
 */
class Tabs extends Extension {
  name = "Tabs";

  constructor(name) {
    super(name);
  }

  init() {
    document.addEventListener("hidden.bs.tab", (event) => {
      const pane = this.paneFor(event.target);
      if (!pane) return;
      pane.querySelectorAll("video").forEach((video) => video.pause());
    });

    document.addEventListener("shown.bs.tab", (event) => {
      const pane = this.paneFor(event.target);
      if (!pane) return;

      pane.querySelectorAll("video[autoplay]").forEach((video) => {
        const playing = video.play();
        if (playing && playing.catch) playing.catch(() => {});
      });

      pane.querySelectorAll("swiper-slider").forEach((el) => {
        if (el.instance) {
          el.instance.update();
          if (el.instance.navigation) {
            el.instance.navigation.update();
          }
        }
      });
    });

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener("shopify:block:select", (event) => {
        const button = event.target.closest('button[data-bs-toggle="tab"]');
        if (button && window.bootstrap && window.bootstrap.Tab) {
          window.bootstrap.Tab.getOrCreateInstance(button).show();
        }
      });
    }
  }

  onReady() {
    // Browsers still autoplay muted videos inside display:none panes, so
    // pause anything that did not load inside the active pane.
    document.querySelectorAll(".tab-pane:not(.active) video").forEach((video) => video.pause());
  }

  paneFor(button) {
    const selector = button && button.getAttribute("data-bs-target");
    return selector ? document.querySelector(selector) : null;
  }
}

export default Tabs;
